export enum EventType {
  Issue = 'Issue',
  Redeem = 'Redeem'
}
